// extracted by mini-css-extract-plugin
module.exports = {"root":"styles__root___2HE8g"};